export const COMMON_SAVE_CRASH_REPORT_BEGIN = 'COMMON_SAVE_CRASH_REPORT_BEGIN';
export const COMMON_SAVE_CRASH_REPORT_SUCCESS = 'COMMON_SAVE_CRASH_REPORT_SUCCESS';
export const COMMON_SAVE_CRASH_REPORT_FAILURE = 'COMMON_SAVE_CRASH_REPORT_FAILURE';
export const COMMON_SAVE_CRASH_REPORT_DISMISS_ERROR = 'COMMON_SAVE_CRASH_REPORT_DISMISS_ERROR';
export const COMMON_LOAD_PROJECT_VERSION_BEGIN = 'COMMON_LOAD_PROJECT_VERSION_BEGIN';
export const COMMON_LOAD_PROJECT_VERSION_SUCCESS = 'COMMON_LOAD_PROJECT_VERSION_SUCCESS';
export const COMMON_LOAD_PROJECT_VERSION_FAILURE = 'COMMON_LOAD_PROJECT_VERSION_FAILURE';
export const COMMON_LOAD_PROJECT_VERSION_DISMISS_ERROR = 'COMMON_LOAD_PROJECT_VERSION_DISMISS_ERROR';
